var _circle, _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallSummaryModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.2,
    cy: 18,
    r: 18,
    fill: "#444444"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1001 9.89941L21.8001 17.0994L19.1001 14.3994",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0953 29.2482C21.2718 29.2482 20.115 28.9504 18.3828 27.9826C16.2764 26.8014 14.6471 25.7108 12.552 23.6213C10.5321 21.6026 9.54913 20.2956 8.1734 17.7922C6.61921 14.9657 6.88415 13.484 7.1803 12.8508C7.53299 12.094 8.05358 11.6413 8.72647 11.192C9.10867 10.9416 9.51313 10.7269 9.93473 10.5507C9.97691 10.5326 10.0161 10.5153 10.0512 10.4997C10.26 10.4056 10.5764 10.2634 10.9772 10.4153C11.2446 10.5157 11.4834 10.7212 11.8572 11.0903C12.6238 11.8463 13.6713 13.53 14.0577 14.3569C14.3172 14.9142 14.4889 15.2821 14.4893 15.6947C14.4893 16.1777 14.2463 16.5502 13.9514 16.9523C13.8961 17.0278 13.8413 17.0999 13.7881 17.17C13.4671 17.5918 13.3966 17.7138 13.443 17.9314C13.5371 18.3689 14.2387 19.6713 15.3917 20.8217C16.5447 21.9722 17.8094 22.6294 18.2486 22.7231C18.4756 22.7716 18.6 22.6982 19.0354 22.3658C19.0979 22.3181 19.162 22.2687 19.2291 22.2194C19.6788 21.8848 20.034 21.6482 20.5057 21.6482H20.5082C20.9187 21.6482 21.2701 21.8262 21.8523 22.1198C22.6117 22.5029 24.346 23.5369 25.1066 24.3043C25.4766 24.6772 25.6829 24.9152 25.7837 25.1822C25.9356 25.5843 25.7926 25.8994 25.6994 26.1103C25.6837 26.1454 25.6664 26.1837 25.6483 26.2264C25.4707 26.6472 25.2548 27.0508 25.0033 27.4321C24.5548 28.1029 24.1004 28.6222 23.3419 28.9753C22.9524 29.1595 22.5261 29.2529 22.0953 29.2482Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallSummaryModal);
export default __webpack_public_path__ + "static/media/call-summary-modal.d6167731976987e5de4f9ab1163374af.svg";
export { ForwardRef as ReactComponent };